DR.results = DR.results || {};
DR.results.struct = DR.results.struct || {};
DR.results.select = DR.results.select || {};
/** @extends {DR._Base} */
DR.results.struct.Team = function(par){
	/** @private */
	this._t = 1066;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.disqualified)) this.disqualified = Boolean(par.disqualified);
	if(DR._Base.is(par.duration)) this.duration = (parseInt(par.duration)||0);
	if(DR._Base.is(par.place)) this.place = (parseInt(par.place)||0);
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
	if(DR._Base.is(par.team)) this.team = DR._Base.cast(par.team);
};
DR._Base._types[1066] = DR.results.struct.Team;
DR.results.struct.Team[__P] = new DR._Base;
DR.results.struct.Team[__P][__C] = DR.results.struct.Team;
/** @type {Boolean} */
DR.results.struct.Team.prototype.disqualified = null;
/** @type {Number} */
DR.results.struct.Team.prototype.duration = null;
/** @type {Number} */
DR.results.struct.Team.prototype.place = null;
/** @type {Number} */
DR.results.struct.Team.prototype.points = null;
/** @type {DR.teams.struct.Team} */
DR.results.struct.Team.prototype.team = null;

/** @extends {DR._Base} */
DR.results.struct.Task = function(par){
	/** @private */
	this._t = 1071;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
	if(DR._Base.is(par.type)) this.type = String(par.type||'');
};
DR._Base._types[1071] = DR.results.struct.Task;
DR.results.struct.Task.TYPE_IMAGEMATCH = "imagematch";
DR.results.struct.Task.TYPE_QUESTION = "question";
DR.results.struct.Task.TYPE_PACMAN = "pacman";
DR.results.struct.Task.TYPE_BRAINTEASER = "brainteaser";
DR.results.struct.Task.TYPE_CRAZYWOLF = "crazywolf";
DR.results.struct.Task.TYPE_HOTCOLD = "hotcold";
DR.results.struct.Task.TYPE_PENALTY = "penalty";
DR.results.struct.Task.TYPE_CODER = "coder";
DR.results.struct.Task.TYPE_FINISH = "finish";
DR.results.struct.Task.TYPE_DETECTIVE = "detective";
DR.results.struct.Task.TYPE_TREASURE = "treasure";
DR.results.struct.Task.TYPE_GOLDDIGGER = "golddigger";
DR.results.struct.Task[__P] = new DR._Base;
DR.results.struct.Task[__P][__C] = DR.results.struct.Task;
/** @type {Number} */
DR.results.struct.Task.prototype.points = null;
/** @type {String} */
DR.results.struct.Task.prototype.type = null;

/** @extends {DR._Base} */
DR.results.struct.RoutePath = function(par){
	/** @private */
	this._t = 1268;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.coordinates)){
		var tmp = [];
		for( var k in par.coordinates ) tmp.push(DR._Base.cast(par.coordinates [k]));
		this.coordinates = tmp;
	}
};
DR._Base._types[1268] = DR.results.struct.RoutePath;
DR.results.struct.RoutePath[__P] = new DR._Base;
DR.results.struct.RoutePath[__P][__C] = DR.results.struct.RoutePath;
/** @type {Array.<DR.roadgames.struct.Coordinates>} */
DR.results.struct.RoutePath.prototype.coordinates = null;

/** @extends {DR._Base} */
DR.results.struct.Results = function(par){
	/** @private */
	this._t = 1067;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.fullPg)) this.fullPg = Boolean(par.fullPg);
	if(DR._Base.is(par.myTeam)) this.myTeam = DR._Base.cast(par.myTeam);
	if(DR._Base.is(par.teams)){
		var tmp = [];
		for( var k in par.teams ) tmp.push(DR._Base.cast(par.teams [k]));
		this.teams = tmp;
	}
};
DR._Base._types[1067] = DR.results.struct.Results;
DR.results.struct.Results[__P] = new DR._Base;
DR.results.struct.Results[__P][__C] = DR.results.struct.Results;
/** @type {Boolean} */
DR.results.struct.Results.prototype.fullPg = null;
/** @type {DR.results.struct.Team|null} */
DR.results.struct.Results.prototype.myTeam = null;
/** @type {Array.<DR.results.struct.Team>} */
DR.results.struct.Results.prototype.teams = null;

/** @extends {DR._Base} */
DR.results.struct.DetailedTeam = function(par){
	/** @private */
	this._t = 1072;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.hasRoute)) this.hasRoute = Boolean(par.hasRoute);
	if(DR._Base.is(par.tasks)){
		var tmp = [];
		for( var k in par.tasks ) tmp.push(DR._Base.cast(par.tasks [k]));
		this.tasks = tmp;
	}
	if(DR._Base.is(par.team)) this.team = DR._Base.cast(par.team);
};
DR._Base._types[1072] = DR.results.struct.DetailedTeam;
DR.results.struct.DetailedTeam[__P] = new DR._Base;
DR.results.struct.DetailedTeam[__P][__C] = DR.results.struct.DetailedTeam;
/** @type {Boolean} */
DR.results.struct.DetailedTeam.prototype.hasRoute = null;
/** @type {Array.<DR.results.struct.Task>} */
DR.results.struct.DetailedTeam.prototype.tasks = null;
/** @type {DR.results.struct.Team} */
DR.results.struct.DetailedTeam.prototype.team = null;

/** @extends {DR._Base} */
DR.results.struct.CrazyWolf = function(par){
	/** @private */
	this._t = 1073;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
	if(DR._Base.is(par.tasks)){
		var tmp = [];
		for( var k in par.tasks ) tmp.push(DR._Base.cast(par.tasks [k]));
		this.tasks = tmp;
	}
};
DR._Base._types[1073] = DR.results.struct.CrazyWolf;
DR.results.struct.CrazyWolf[__P] = new DR._Base;
DR.results.struct.CrazyWolf[__P][__C] = DR.results.struct.CrazyWolf;
/** @type {Number} */
DR.results.struct.CrazyWolf.prototype.points = null;
/** @type {Array.<DR.crazywolf.struct.Task>} */
DR.results.struct.CrazyWolf.prototype.tasks = null;

/** @extends {DR._Base} */
DR.results.struct.BrainTeaser = function(par){
	/** @private */
	this._t = 1075;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
	if(DR._Base.is(par.questions)){
		var tmp = [];
		for( var k in par.questions ) tmp.push(DR._Base.cast(par.questions [k]));
		this.questions = tmp;
	}
};
DR._Base._types[1075] = DR.results.struct.BrainTeaser;
DR.results.struct.BrainTeaser[__P] = new DR._Base;
DR.results.struct.BrainTeaser[__P][__C] = DR.results.struct.BrainTeaser;
/** @type {Number} */
DR.results.struct.BrainTeaser.prototype.points = null;
/** @type {Array.<DR.brainteaser.struct.Question>} */
DR.results.struct.BrainTeaser.prototype.questions = null;

/** @extends {DR._Base} */
DR.results.struct.Pacman = function(par){
	/** @private */
	this._t = 1077;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.games)){
		var tmp = [];
		for( var k in par.games ) tmp.push(DR._Base.cast(par.games [k]));
		this.games = tmp;
	}
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
};
DR._Base._types[1077] = DR.results.struct.Pacman;
DR.results.struct.Pacman[__P] = new DR._Base;
DR.results.struct.Pacman[__P][__C] = DR.results.struct.Pacman;
/** @type {Array.<DR.pacman.struct.Game>} */
DR.results.struct.Pacman.prototype.games = null;
/** @type {Number} */
DR.results.struct.Pacman.prototype.points = null;

/** @extends {DR._Base} */
DR.results.struct.HotCold = function(par){
	/** @private */
	this._t = 1079;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.locations)){
		var tmp = [];
		for( var k in par.locations ) tmp.push(DR._Base.cast(par.locations [k]));
		this.locations = tmp;
	}
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
};
DR._Base._types[1079] = DR.results.struct.HotCold;
DR.results.struct.HotCold[__P] = new DR._Base;
DR.results.struct.HotCold[__P][__C] = DR.results.struct.HotCold;
/** @type {Array.<DR.hotcold.struct.Point>} */
DR.results.struct.HotCold.prototype.locations = null;
/** @type {Number} */
DR.results.struct.HotCold.prototype.points = null;

/** @extends {DR._Base} */
DR.results.struct.Questions = function(par){
	/** @private */
	this._t = 1081;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
	if(DR._Base.is(par.questions)){
		var tmp = [];
		for( var k in par.questions ) tmp.push(DR._Base.cast(par.questions [k]));
		this.questions = tmp;
	}
};
DR._Base._types[1081] = DR.results.struct.Questions;
DR.results.struct.Questions[__P] = new DR._Base;
DR.results.struct.Questions[__P][__C] = DR.results.struct.Questions;
/** @type {Number} */
DR.results.struct.Questions.prototype.points = null;
/** @type {Array.<DR.objects.struct.ItemQuestion>} */
DR.results.struct.Questions.prototype.questions = null;

/** @extends {DR._Base} */
DR.results.struct.ImageMatch = function(par){
	/** @private */
	this._t = 1084;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.images)){
		var tmp = [];
		for( var k in par.images ) tmp.push(DR._Base.cast(par.images [k]));
		this.images = tmp;
	}
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
};
DR._Base._types[1084] = DR.results.struct.ImageMatch;
DR.results.struct.ImageMatch[__P] = new DR._Base;
DR.results.struct.ImageMatch[__P][__C] = DR.results.struct.ImageMatch;
/** @type {Array.<DR.objects.struct.ItemImageMatch>} */
DR.results.struct.ImageMatch.prototype.images = null;
/** @type {Number} */
DR.results.struct.ImageMatch.prototype.points = null;

/** @extends {DR._Base} */
DR.results.struct.Coder = function(par){
	/** @private */
	this._t = 1104;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
	if(DR._Base.is(par.tasks)){
		var tmp = [];
		for( var k in par.tasks ) tmp.push(DR._Base.cast(par.tasks [k]));
		this.tasks = tmp;
	}
};
DR._Base._types[1104] = DR.results.struct.Coder;
DR.results.struct.Coder[__P] = new DR._Base;
DR.results.struct.Coder[__P][__C] = DR.results.struct.Coder;
/** @type {Number} */
DR.results.struct.Coder.prototype.points = null;
/** @type {Array.<DR.coder.struct.Task>} */
DR.results.struct.Coder.prototype.tasks = null;

/** @extends {DR._Base} */
DR.results.struct.Detective = function(par){
	/** @private */
	this._t = 1168;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.cases)){
		var tmp = [];
		for( var k in par.cases ) tmp.push(DR._Base.cast(par.cases [k]));
		this.cases = tmp;
	}
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
};
DR._Base._types[1168] = DR.results.struct.Detective;
DR.results.struct.Detective[__P] = new DR._Base;
DR.results.struct.Detective[__P][__C] = DR.results.struct.Detective;
/** @type {Array.<DR.detective.struct.Case>} */
DR.results.struct.Detective.prototype.cases = null;
/** @type {Number} */
DR.results.struct.Detective.prototype.points = null;

/** @extends {DR._Base} */
DR.results.struct.Treasure = function(par){
	/** @private */
	this._t = 1223;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
	if(DR._Base.is(par.treasure)){
		var tmp = [];
		for( var k in par.treasure ) tmp.push(DR._Base.cast(par.treasure [k]));
		this.treasure = tmp;
	}
};
DR._Base._types[1223] = DR.results.struct.Treasure;
DR.results.struct.Treasure[__P] = new DR._Base;
DR.results.struct.Treasure[__P][__C] = DR.results.struct.Treasure;
/** @type {Number} */
DR.results.struct.Treasure.prototype.points = null;
/** @type {Array.<DR.treasure.struct.Item>} */
DR.results.struct.Treasure.prototype.treasure = null;

/** @extends {DR._Base} */
DR.results.struct.Route = function(par){
	/** @private */
	this._t = 1269;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.distance)) this.distance = (parseInt(par.distance)||0);
	if(DR._Base.is(par.paths)){
		var tmp = [];
		for( var k in par.paths ) tmp.push(DR._Base.cast(par.paths [k]));
		this.paths = tmp;
	}
};
DR._Base._types[1269] = DR.results.struct.Route;
DR.results.struct.Route[__P] = new DR._Base;
DR.results.struct.Route[__P][__C] = DR.results.struct.Route;
/** @type {Number} */
DR.results.struct.Route.prototype.distance = null;
/** @type {Array.<DR.results.struct.RoutePath>} */
DR.results.struct.Route.prototype.paths = null;

/** @extends {DR._Base} */
DR.results.struct.GoldDigger = function(par){
	/** @private */
	this._t = 1278;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.points)) this.points = (parseInt(par.points)||0);
	if(DR._Base.is(par.tasks)){
		var tmp = [];
		for( var k in par.tasks ) tmp.push(DR._Base.cast(par.tasks [k]));
		this.tasks = tmp;
	}
};
DR._Base._types[1278] = DR.results.struct.GoldDigger;
DR.results.struct.GoldDigger[__P] = new DR._Base;
DR.results.struct.GoldDigger[__P][__C] = DR.results.struct.GoldDigger;
/** @type {Number} */
DR.results.struct.GoldDigger.prototype.points = null;
/** @type {Array.<DR.golddigger.struct.Task>} */
DR.results.struct.GoldDigger.prototype.tasks = null;

/** @extends {DR._Method} */
DR.results.Get = function(par){
	this.select = [];
	/** @private */
	this._t = 1068;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1068] = DR.results.Get;
DR.results.Get[__CL] = "Results__Get";
DR.results.Get.TYPE_BASETIME = "basetime";
DR.results.Get.TYPE_ALLTIME = "alltime";
DR.results.Get[__P] = new DR._Method;
DR.results.Get[__P][__C] = DR.results.Get;
/** @type {Boolean|null} */
DR.results.Get.prototype.byTime = null;
/** @type {Number|null} */
DR.results.Get.prototype.lastPlace = null;
/** @type {String|null} */
DR.results.Get.prototype.type = null;
/** @type {DR.results.struct.Results} */
DR.results.Get.prototype.re = null;

/** @extends {DR._Method} */
DR.results.GetTeam = function(par){
	this.select = [];
	/** @private */
	this._t = 1070;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1070] = DR.results.GetTeam;
DR.results.GetTeam[__CL] = "Results__GetTeam";
DR.results.GetTeam.TYPE_BASETIME = "basetime";
DR.results.GetTeam.TYPE_ALLTIME = "alltime";
DR.results.GetTeam[__P] = new DR._Method;
DR.results.GetTeam[__P][__C] = DR.results.GetTeam;
/** @type {Number|null} */
DR.results.GetTeam.prototype.teamId = null;
/** @type {String|null} */
DR.results.GetTeam.prototype.type = null;
/** @type {DR.results.struct.DetailedTeam} */
DR.results.GetTeam.prototype.re = null;

/** @extends {DR._Method} */
DR.results.GetCrazyWolf = function(par){
	this.select = [];
	/** @private */
	this._t = 1074;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1074] = DR.results.GetCrazyWolf;
DR.results.GetCrazyWolf[__CL] = "Results__GetCrazyWolf";
DR.results.GetCrazyWolf[__P] = new DR._Method;
DR.results.GetCrazyWolf[__P][__C] = DR.results.GetCrazyWolf;
/** @type {DR.results.struct.CrazyWolf} */
DR.results.GetCrazyWolf.prototype.re = null;

/** @extends {DR._Method} */
DR.results.GetBrainTeaser = function(par){
	this.select = [];
	/** @private */
	this._t = 1076;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1076] = DR.results.GetBrainTeaser;
DR.results.GetBrainTeaser[__CL] = "Results__GetBrainTeaser";
DR.results.GetBrainTeaser[__P] = new DR._Method;
DR.results.GetBrainTeaser[__P][__C] = DR.results.GetBrainTeaser;
/** @type {DR.results.struct.BrainTeaser} */
DR.results.GetBrainTeaser.prototype.re = null;

/** @extends {DR._Method} */
DR.results.GetPacman = function(par){
	this.select = [];
	/** @private */
	this._t = 1078;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1078] = DR.results.GetPacman;
DR.results.GetPacman[__CL] = "Results__GetPacman";
DR.results.GetPacman[__P] = new DR._Method;
DR.results.GetPacman[__P][__C] = DR.results.GetPacman;
/** @type {DR.results.struct.Pacman} */
DR.results.GetPacman.prototype.re = null;

/** @extends {DR._Method} */
DR.results.GetHotCold = function(par){
	this.select = [];
	/** @private */
	this._t = 1080;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1080] = DR.results.GetHotCold;
DR.results.GetHotCold[__CL] = "Results__GetHotCold";
DR.results.GetHotCold[__P] = new DR._Method;
DR.results.GetHotCold[__P][__C] = DR.results.GetHotCold;
/** @type {DR.results.struct.HotCold} */
DR.results.GetHotCold.prototype.re = null;

/** @extends {DR._Method} */
DR.results.GetQuestions = function(par){
	this.select = [];
	/** @private */
	this._t = 1083;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1083] = DR.results.GetQuestions;
DR.results.GetQuestions[__CL] = "Results__GetQuestions";
DR.results.GetQuestions[__P] = new DR._Method;
DR.results.GetQuestions[__P][__C] = DR.results.GetQuestions;
/** @type {DR.results.struct.Questions} */
DR.results.GetQuestions.prototype.re = null;

/** @extends {DR._Method} */
DR.results.GetImageMatch = function(par){
	this.select = [];
	/** @private */
	this._t = 1085;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1085] = DR.results.GetImageMatch;
DR.results.GetImageMatch[__CL] = "Results__GetImageMatch";
DR.results.GetImageMatch[__P] = new DR._Method;
DR.results.GetImageMatch[__P][__C] = DR.results.GetImageMatch;
/** @type {DR.results.struct.ImageMatch} */
DR.results.GetImageMatch.prototype.re = null;

/** @extends {DR._Method} */
DR.results.GetCoder = function(par){
	this.select = [];
	/** @private */
	this._t = 1105;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1105] = DR.results.GetCoder;
DR.results.GetCoder[__CL] = "Results__GetCoder";
DR.results.GetCoder[__P] = new DR._Method;
DR.results.GetCoder[__P][__C] = DR.results.GetCoder;
/** @type {DR.results.struct.Coder} */
DR.results.GetCoder.prototype.re = null;

/** @extends {DR._Method} */
DR.results.GetDetective = function(par){
	this.select = [];
	/** @private */
	this._t = 1169;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1169] = DR.results.GetDetective;
DR.results.GetDetective[__CL] = "Results__GetDetective";
DR.results.GetDetective[__P] = new DR._Method;
DR.results.GetDetective[__P][__C] = DR.results.GetDetective;
/** @type {DR.results.struct.Detective} */
DR.results.GetDetective.prototype.re = null;

/** @extends {DR._Method} */
DR.results.GetTreasure = function(par){
	this.select = [];
	/** @private */
	this._t = 1224;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1224] = DR.results.GetTreasure;
DR.results.GetTreasure[__CL] = "Results__GetTreasure";
DR.results.GetTreasure[__P] = new DR._Method;
DR.results.GetTreasure[__P][__C] = DR.results.GetTreasure;
/** @type {DR.results.struct.Treasure} */
DR.results.GetTreasure.prototype.re = null;

/** @extends {DR._Method} */
DR.results.GetRoute = function(par){
	this.select = [];
	/** @private */
	this._t = 1270;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1270] = DR.results.GetRoute;
DR.results.GetRoute[__CL] = "Results__GetRoute";
DR.results.GetRoute[__P] = new DR._Method;
DR.results.GetRoute[__P][__C] = DR.results.GetRoute;
/** @type {DR.results.struct.Route} */
DR.results.GetRoute.prototype.re = null;

/** @extends {DR._Method} */
DR.results.GetGoldDigger = function(par){
	this.select = [];
	/** @private */
	this._t = 1279;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1279] = DR.results.GetGoldDigger;
DR.results.GetGoldDigger[__CL] = "Results__GetGoldDigger";
DR.results.GetGoldDigger[__P] = new DR._Method;
DR.results.GetGoldDigger[__P][__C] = DR.results.GetGoldDigger;
/** @type {DR.results.struct.GoldDigger} */
DR.results.GetGoldDigger.prototype.re = null;

D.loaded();